import {Commande} from '@/models';

export default [
	{
		path: '/commandes',
		name: 'commandes',
		meta: {
			title: 'Liste des commandes',
			granted: [ 'API_GET_COMMANDE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Commande.vue')
	},
	{
		path: '/historique-commandes',
		name: 'historique-commandes',
		meta: {
			title: 'Historiques des commandes',
			granted: [ 'API_GET_COMMANDE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/CommandeHistorique.vue')
	},
	{
		path: '/commande/show/:id',
		name: 'commande-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Commande/Show.vue'),
				class: Commande
			}),
			editRoute: { name: 'commande-edit' },
		},
		meta: {
			title: 'Détail d\'un commande',
			granted: [ 'API_GET_COMMANDE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/commande/edit/:id',
		name: 'commande-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Commande/Edit.vue'),
				class: Commande
			}),
		},
		meta: {
			title: 'Edition d\'un commande',
			granted: [ 'API_PUT_COMMANDE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
